import { Empty } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Fragment } from "react/jsx-runtime";
import { useGetPublicCoursesQuery } from "../../../../app/features/courses/courses.api";
import LeftPaginationArrowIcon from "../../../../assets/icons/LeftPaginationArrowIcon";
import RightPaginationArrowIcon from "../../../../assets/icons/RightPaginationArrowIcon";
import CustomPagination from "../../../../components/CustomPagination";
import CourseItem from "../../../../components/ui/CourseItem";
import CourseItemSkeleton from "../../../../components/ui/CourseItemSkeleton";
import useDebounce from "../../../../hooks/useDebounce";
import useError from "../../../../hooks/useError";
import useFilters from "../../../../hooks/useFilters";
import { useQueryFilters } from "../../../../hooks/useQueryFilters";
import { durationValues } from "../filters";

export default function CourseList() {
  const { limit, page, handlePagination } = useFilters();
  const navigate = useNavigate();
  const { filters } = useQueryFilters();
  const { keyword, handleInputSearch } = useDebounce();

  const { isLoading, isFetching, error, data } = useGetPublicCoursesQuery({
    limit: limit,
    // page: page,
    q: keyword as string,
    categoryId: filters?.categoryId ? Number(filters.categoryId) : undefined,
    durationMin: filters?.duration
      ? durationValues[filters.duration as keyof typeof durationValues]?.[0]
      : undefined,
    durationMax: filters?.duration
      ? durationValues[filters.duration as keyof typeof durationValues]?.[1]
      : undefined,
    level: filters?.level ? (filters.level as string) : undefined,
  });
  useError(error, "কোর্স লোড করতে ব্যর্থ হয়েছে");

  useEffect(() => {
    handleInputSearch((filters.search as string) || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.search]);

  return (
    <section className="py-20 container mini-container">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {isLoading || isFetching ? (
          Array.from({ length: 6 }).map((_, index) => (
            <CourseItemSkeleton key={index} />
          ))
        ) : (data?.items || [])?.length > 0 ? (
          <Fragment>
            {data?.items?.map((course) => (
              <CourseItem
                key={course?.id}
                img={course?.thumbnailUrl}
                title={course?.title}
                category={course?.category?.name}
                description={course?.description}
                price={course?.price}
                offerPrice={course?.offerPrice}
                tags={course?.CourseTag?.map((tag) => ({
                  title: tag.Tag?.name,
                  icon: undefined,
                }))}
                id={course?.id}
                courseUuid={course?.uuid}
                onMoreButton={() => navigate(`${course?.id}`)}
              />
            ))}
          </Fragment>
        ) : (
          <div className="flex items-center justify-center md:col-span-2 lg:col-span-3">
            <Empty description="কোর্স সমূহ পাওয়া যায়নি" />
          </div>
        )}
      </div>

      {(data?.items || [])?.length > 0 && (
        <CustomPagination
          limit={limit}
          page={page}
          total={1}
          handlePagination={handlePagination}
          prevIcon={<LeftPaginationArrowIcon />}
          nextIcon={<RightPaginationArrowIcon />}
          className="border-none"
          paginationClassName="course_pagination pt-4"
          hidePage
        />
      )}
    </section>
  );
}
